import '../shared/styles/app.css';
import AppRoutes from './routes/AppRoutes';

function App() {
    return <AppRoutes />;
}

export default App;
